import { useCallback, useEffect, useMemo, useState } from 'react';
import TaskHistoryView from '../components/TaskHistoryView';
import LogView from '../components/LogView';
import { useParams } from 'react-router-dom';

interface ViewTaskPageProps {
  taskID?: string;
  workstreamID?: string;
}

export default function ViewTaskPage(props: ViewTaskPageProps) {
  const params = useParams();
  const taskID = props.taskID ?? params.taskID;
  const workstreamID = props.workstreamID ?? params.workstreamID;
  const initialTurnID = params.turnID;
  const [activeSelection, setActiveSelection] = useState<{
    taskID?: string;
    turnID?: string;
  }>({
    taskID,
    turnID: initialTurnID,
  });

  useEffect(() => {
    setActiveSelection((prev) => {
      if (prev.taskID === taskID && prev.turnID === initialTurnID) {
        return prev;
      }
      return { taskID, turnID: initialTurnID };
    });
  }, [taskID, initialTurnID]);

  const handleSelectTurn = useCallback(
    (turnID?: string) => {
      setActiveSelection({ taskID, turnID });
    },
    [taskID]
  );

  const activeTurnID = useMemo(() => {
    return activeSelection.taskID === taskID ? activeSelection.turnID : undefined;
  }, [activeSelection, taskID]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100vh',
        paddingTop: '20px',
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          flex: 1,
          display: 'flex',
          height: '100%',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            width: '400px',
            borderRight: '1px solid #ccc',
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0,
          }}
        >
        <TaskHistoryView
            taskID={taskID}
            workstreamID={workstreamID}
            selectedTurnID={activeTurnID}
            onSelectTurn={handleSelectTurn}
          />
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0,
          }}
        >
          <LogView taskID={taskID} turnID={activeTurnID} workstreamID={workstreamID} />
        </div>
      </div>
    </div>
  );
}
